import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const CONTOUR_LINES_PARAMS = [
  {
    kind: 'int',
    key: 'levels',
    label: 'Höhenlinien',
    min: 2,
    max: 200,
    step: 1,
    scale: 'log',
    default: 34,
    bulkRange: [8, 90],
    group: 'Topografie',
  },
  {
    kind: 'float',
    key: 'noiseMix',
    label: 'Rauschanteil',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.45,
    group: 'Topografie',
    tooltip: '0 zeigt reine Distanzfeld-Ringe, 1 reine Rauschtopografie.',
  },
  {
    kind: 'float',
    key: 'noiseScale',
    label: 'Noise-Skala',
    min: 0.0004,
    max: 0.02,
    step: 0.0001,
    scale: 'log',
    default: 0.0032,
    precision: 4,
    unit: '1/px',
    group: 'Topografie',
  },
  {
    kind: 'int',
    key: 'octaves',
    label: 'Oktaven',
    min: 1,
    max: 6,
    step: 1,
    default: 3,
    group: 'Topografie',
  },
  {
    kind: 'float',
    key: 'warp',
    label: 'Verzerrung',
    min: 0,
    max: 200,
    step: 1,
    default: 0,
    unit: 'px',
    bulkRange: [0, 90],
    group: 'Topografie',
    tooltip: 'Verschiebt das Höhenfeld selbst durch ein zweites Rauschfeld.',
  },
  {
    kind: 'float',
    key: 'resolution',
    label: 'Gitterweite',
    min: 1,
    max: 16,
    step: 0.5,
    default: 3,
    unit: 'px',
    neverRandomise: true,
    group: 'Topografie',
    tooltip: 'Feineres Gitter = glattere Linien, mehr Rechenzeit.',
  },

  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Linienstärke',
    min: 0.2,
    max: 8,
    step: 0.1,
    default: 1,
    unit: 'px',
    group: 'Darstellung',
  },
  {
    kind: 'bool',
    key: 'fill',
    label: 'Zwischen den Linien füllen',
    default: false,
    group: 'Darstellung',
    tooltip: 'Zeichnet jede Höhenstufe als Fläche statt als Linie.',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.85,
    group: 'Darstellung',
  },
  {
    kind: 'enum',
    key: 'clip',
    label: 'Bereich',
    default: 'all',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'all', label: 'Überall' },
      { value: 'outside', label: 'Aussen' },
      { value: 'inside', label: 'Innen' },
    ],
  },

  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'moss' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type ContourLinesValues = SchemaValues<typeof CONTOUR_LINES_PARAMS>;
